import { render, staticRenderFns } from "./InformationList.vue?vue&type=template&id=153bb874"
import script from "./InformationList.vue?vue&type=script&lang=js"
export * from "./InformationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports